var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoicon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_6619)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7778 40.3098C17.7778 36.5815 20.597 33.5801 24.0988 33.5801C27.6006 33.5801 30.4198 36.5815 30.4198 40.3098V56.875C30.4198 60.6032 27.6006 63.6048 24.0988 63.6048C20.597 63.6048 17.7778 60.6032 17.7778 56.875V40.3098Z",
    fill: "#E01E5A",
    stroke: "#E01E5A",
    strokeWidth: 0.790123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3097 46.2221C36.5815 46.2221 33.5801 43.4029 33.5801 39.9011C33.5801 36.3992 36.5815 33.5801 40.3097 33.5801H56.8751C60.6033 33.5801 63.6048 36.3992 63.6048 39.9011C63.6048 43.4029 60.6033 46.2221 56.8751 46.2221H40.3097Z",
    fill: "#ECB22D",
    stroke: "#ECB22D",
    strokeWidth: 0.790123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5801 7.12515C33.5801 3.39695 36.3992 0.395508 39.9011 0.395508C43.4029 0.395508 46.222 3.39695 46.222 7.12515V23.6905C46.222 27.4188 43.4029 30.4202 39.9011 30.4202C36.3992 30.4202 33.5801 27.4188 33.5801 23.6905V7.12515Z",
    fill: "#2FB67C",
    stroke: "#2FB67C",
    strokeWidth: 0.790123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12466 30.4193C3.39646 30.4193 0.39502 27.6002 0.39502 24.0983C0.39502 20.5965 3.39646 17.7773 7.12466 17.7773H23.69C27.4183 17.7773 30.4197 20.5965 30.4197 24.0983C30.4197 27.6002 27.4183 30.4193 23.69 30.4193H7.12466Z",
    fill: "#36C5F1",
    stroke: "#36C5F1",
    strokeWidth: 0.790123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5801 57.2849C33.5783 58.1154 33.7406 58.9382 34.0576 59.7059C34.3747 60.4736 34.8402 61.1711 35.4275 61.7584C36.0148 62.3457 36.7124 62.8113 37.48 63.1283C38.2477 63.4453 39.0705 63.6076 39.9011 63.6059C43.4029 63.6059 46.2221 60.7867 46.2221 57.2849C46.2238 56.4543 46.0615 55.6315 45.7445 54.8638C45.4275 54.0961 44.9619 53.3986 44.3746 52.8113C43.7873 52.224 43.0898 51.7585 42.3221 51.4414C41.5544 51.1244 40.7317 50.9621 39.9011 50.9639H33.5801V57.2849Z",
    fill: "#ECB22D",
    stroke: "#ECB22D",
    strokeWidth: 0.790123,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2839 30.4203H50.9629V24.0993C50.9629 20.5975 53.7821 17.7783 57.2839 17.7783C60.7857 17.7783 63.6049 20.5975 63.6049 24.0993C63.6049 27.6011 60.7857 30.4203 57.2839 30.4203Z",
    fill: "#2FB67C",
    stroke: "#2FB67C",
    strokeWidth: 0.790123,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71602 33.5811H13.037V39.902C13.037 43.4039 10.2178 46.223 6.71602 46.223C5.88544 46.2248 5.06269 46.0625 4.29499 45.7455C3.52729 45.4284 2.82977 44.9629 2.24246 44.3756C1.65515 43.7883 1.18962 43.0908 0.872584 42.3231C0.555552 41.5554 0.393263 40.7326 0.395034 39.902C0.395034 36.4002 3.21419 33.5811 6.71602 33.5811Z",
    fill: "#E01E5A",
    stroke: "#E01E5A",
    strokeWidth: 0.790123,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4198 6.71651V13.0375H24.0988C23.2683 13.0393 22.4455 12.877 21.6778 12.5599C20.9101 12.2429 20.2126 11.7774 19.6253 11.1901C19.038 10.6028 18.5724 9.90524 18.2554 9.13754C17.9384 8.36984 17.7761 7.54709 17.7778 6.71651C17.7778 3.21468 20.597 0.395522 24.0988 0.395522C24.9294 0.393752 25.7522 0.55604 26.5199 0.873072C27.2876 1.1901 27.9851 1.65564 28.5724 2.24295C29.1597 2.83026 29.6252 3.52778 29.9423 4.29548C30.2593 5.06317 30.4216 5.88593 30.4198 6.71651Z",
    fill: "#36C5F1",
    stroke: "#36C5F1",
    strokeWidth: 0.790123,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_6619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon1);
export default __webpack_public_path__ + "static/media/logoicon1.aa8a4d0f5cc6b37a2fb548ef50a2e141.svg";
export { ForwardRef as ReactComponent };